import indexData from '../../mocks/streamers/index.json';
import { streamerSchema } from '../../mocks/streamers/schema';
import type { StreamerData } from '../../mocks/streamers/schema';

const streamerFiles = import.meta.glob('../../mocks/streamers/*.json', { eager: true });

type IndexEntry = { streamerId: string; file: string };

type StreamerIndex = { streamers: IndexEntry[] };

const index = indexData as StreamerIndex;

export async function detectStreamerMode(): Promise<StreamerData | null> {
  if (typeof window === 'undefined') return null;

  const params = new URLSearchParams(window.location.search);
  const streamerId = params.get('streamer');
  if (!streamerId) return null;

  const match = index.streamers.find((entry) => entry.streamerId === streamerId);
  if (!match) return null;

  const filePath = `../../mocks/streamers/${match.file}`;
  const mod = streamerFiles[filePath] as { default?: unknown } | undefined;
  if (!mod?.default) return null;

  const parsed = streamerSchema.safeParse(mod.default);
  if (!parsed.success) {
    try { console.warn('[StreamerMode] Invalid streamer data', parsed.error); } catch {}
    return null;
  }

  return parsed.data;
}
